var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.087 9.75C12.6873 9.75 13.1739 10.2366 13.1739 10.837V16.2391C13.1739 16.8394 12.6873 17.3261 12.087 17.3261C11.4866 17.3261 11 16.8394 11 16.2391V10.837C11 10.2366 11.4866 9.75 12.087 9.75Z",
    fill: "#DE350B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.17391C6.57319 2.17391 2.17391 6.57321 2.17391 12C2.17391 17.4268 6.57318 21.8261 12 21.8261C17.4268 21.8261 21.8261 17.4268 21.8261 12C21.8261 6.57322 17.4268 2.17391 12 2.17391ZM0 12C0 5.3726 5.37256 0 12 0C18.6274 0 24 5.37259 24 12C24 18.6274 18.6274 24 12 24C5.37256 24 0 18.6274 0 12Z",
    fill: "#DE350B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0879,
    cy: 7.53125,
    r: 1,
    fill: "#DE350B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoRed);
export default __webpack_public_path__ + "static/media/info-red.2f6f389df3fb0df214e175a8ef455fc4.svg";
export { ForwardRef as ReactComponent };